import { useTranslation } from "react-i18next";

 function NotFoundPage() {
  const { t, i18n } = useTranslation();
  return (
    <div className="not-found-page">
      <div className="container container-full">
        <div className="not-found-content">
            <h1>{t("notFoundPage.title")}</h1>
            <button className="btn btn-main btn-md pill" onClick={() => window.location.href = `/${i18n.language}`}>{t("notFoundPage.btn")}</button>
            <h2 className="not-found-code">
              <span className="not-found-code__hash">#</span>
              404
            </h2>
        </div>
        <img src="/assets/images/thumbs/not-found-page-img.webp" alt="robot"  className="not-found-img"/>
      </div>
    </div>
  );
}


export default NotFoundPage